import { render, staticRenderFns } from "./PaymentSelect.vue?vue&type=template&id=12442dd9&scoped=true&"
import script from "./PaymentSelect.vue?vue&type=script&lang=js&"
export * from "./PaymentSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12442dd9",
  null
  
)

export default component.exports